import { useEffect, useRef } from 'react'

export const useSyncUncontrolledInput = <T extends HTMLInputElement | HTMLTextAreaElement = HTMLInputElement>(
  value = '',
) => {
  const inputRef = useRef<T>(null)

  useEffect(() => {
    const input = inputRef.current
    if (!input) return

    if (input.value === value) return

    input.value = value
  }, [value])

  return inputRef
}
